import { sharedCalculatorNav, sharedCalculatorTranslations } from './calculatorShared';

export const ka = {
  // Purchased Cars (Win Cars) view tabs
  winCarsView: {
    ourDealers: 'ჩვენი დილერები',
    allAuctionWins: 'ყველა აუქციონის მოგება',
    ourDealersHint: 'მხოლოდ ჩვენი რეგისტრირებული დილერების მიერ შეძენილი ან მიბმული მანქანები.',
    allAuctionWinsHint: 'აუქციონის ნაკადის ყველა მანქანა (საცნობარო).',
  },

  // Navigation
  nav: {
    dashboard: 'მთავარი',
    branches: 'ფილიალები',
    managers: 'მენეჯერები',
    dealers: 'დილერები',
    subdealers: 'სუბდილერები',
    winCars: 'შეძენილი ავტომობილები',
    accounts: 'ანგარიშები',
    auctionFees: 'აუქციონის საფასურები',
    deliveryCost: 'მიწოდების ღირებულება',
    statistics: 'შეთავაზებები',
    watchlist: 'საყურებელი სია',
    tools: 'ხელსაწყოები',
    settings: 'პარამეტრები',
    ...sharedCalculatorNav,
  },

  // Common
  common: {
    add: 'დამატება',
    edit: 'რედაქტირება',
    delete: 'წაშლა',
    save: 'შენახვა',
    cancel: 'გაუქმება',
    create: 'შექმნა',
    update: 'განახლება',
    back: 'უკან',
    refresh: 'განახლება',
    search: 'ძიება',
    actions: 'მოქმედებები',
    status: 'სტატუსი',
    contact: 'კონტაქტი',
    email: 'ელ-ფოსტა',
    phone: 'ტელეფონი',
    name: 'სახელი',
    username: 'ლოგინი',
    password: 'პაროლი',
    confirmPassword: 'პაროლის დადასტურება',
    loading: 'იტვირთება...',
    noDataFound: 'მონაცემები ვერ მოიძებნა',
    total: 'სულ',
    active: 'აქტიური',
    inactive: 'არააქტიური',
    all: 'ყველა',
    filters: 'ფილტრები',
  },

  watchlist: { notFound: 'ვერ მოიძებნა', remove: 'წაშლა სიიდან' },

  // Branches
  branches: {
    title: 'ფილიალების მართვა',
    addBranch: 'ფილიალის დამატება',
    editBranch: 'ფილიალის რედაქტირება',
    createBranch: 'ახალი ფილიალის შექმნა',
    branchName: 'ფილიალის სახელი',
    branchCode: 'ფილიალის კოდი',
    location: 'მდებარეობა',
    country: 'ქვეყანა',
    city: 'ქალაქი',
    address: 'მისამართი',
    totalBranches: 'სულ ფილიალები',
    activeBranches: 'აქტიური ფილიალები',
    totalManagers: 'სულ მენეჯერები',
    totalDealers: 'სულ დილერები',
    totalSubdealers: 'სულ სუბდილერები',
    created: 'შექმნილია',
    backToBranches: 'დაბრუნება ფილიალებზე',
    noBranchesFound: 'ფილიალები ვერ მოიძებნა',
    deleteBranchConfirm: 'დარწმუნებული ხართ, რომ გსურთ ფილიალის წაშლა',
  },

  // Managers
  managers: {
    title: 'მენეჯერების მართვა',
    addManager: 'მენეჯერის დამატება',
    editManager: 'მენეჯერის რედაქტირება',
    createManager: 'ახალი მენეჯერის შექმნა',
    firstName: 'სახელი',
    lastName: 'გვარი',
    assignToBranch: 'ფილიალზე მინიჭება',
    totalManagers: 'სულ მენეჯერები',
    georgiaManagers: 'საქართველოს ფილიალი',
    dubaiManagers: 'დუბაის ფილიალი',
    armeniaManagers: 'სომხეთის ფილიალი',
    activeBids: 'აქტიური ბიდები',
    monthlyRevenue: 'ყოველთვიური შემოსავალი',
    wonAuctions: 'მოგებული აუქციონები',
    backToManagers: 'დაბრუნება მენეჯერებზე',
    noManagersFound: 'მენეჯერები ვერ მოიძებნა',
    deleteManagerConfirm: 'დარწმუნებული ხართ, რომ გსურთ მენეჯერის წაშლა',
  },

  // Dealers
  dealers: {
    title: 'დილერების მართვა',
    addDealer: 'დილერის დამატება',
    editDealer: 'დილერის რედაქტირება',
    createDealer: 'ახალი დილერის შექმნა',
    totalDealers: 'სულ დილერები',
    georgiaDealers: 'საქართველოს დილერები',
    dubaiDealers: 'დუბაის დილერები',
    armeniaDealers: 'სომხეთის დილერები',
    assignToManager: 'მენეჯერზე მინიჭება',
    totalSubdealers: 'სულ სუბდილერები',
    totalSpent: 'სულ დახარჯული',
    successRate: 'წარმატების მაჩვენებელი',
    myBids: 'ჩემი ბიდები და მანქანები',
    subdealersBids: 'სუბდილერების ბიდები და მანქანები',
    allBids: 'ყველა ბიდი და მანქანა',
    myActiveBids: 'ჩემი აქტიური ბიდები',
    subdealersActiveBids: 'სუბდილერების აქტიური ბიდები',
    totalCarsWon: 'სულ მოგებული მანქანები',
    backToDealers: 'დაბრუნება დილერებზე',
    noDealersFound: 'დილერები ვერ მოიძებნა',
    deleteDealerConfirm: 'დარწმუნებული ხართ, რომ გსურთ დილერის წაშლა',
    deleteDealer: 'დილერის წაშლა',
    loadingList: 'დილერები იტვირთება...',
    filtersActiveSuffix: 'ფილტრი აქტიურია',
    quickSearchPlaceholder: 'ძიება სახელით, ლოგინით, ელფოსტით ან ტელეფონით...',
    ctrlFHint: 'Ctrl+F / ⌘F',
    advancedFilters: 'დამატებითი ფილტრები',
    branchFilterPh: 'ფილიალი',
    managerFilterPh: 'მენეჯერი',
    allBranches: 'ყველა ფილიალი',
    allManagers: 'ყველა მენეჯერი',
    clearFilters: 'ფილტრების გასუფთავება',
    pageTotalShowing: 'ნაჩვენებია',
    pageTotalOf: '/',
    pageTotalLabel: 'სულ',
    auctionAccountsTitle: 'აუქციონის ანგარიშები',
    auctionAccountsRequired:
      'აირჩიეთ მინიმუმ ერთი ძირითადი აუქციონის ანგარიში (Copart, IAAI, Manheim ან ACV).',
    passwordLeaveBlank: 'პაროლი (დატოვეთ ცარიელი მიმდინარეს შესანახად)',
    passwordLabel: 'პაროლი',
    phoneLabel: 'ტელეფონი',
    selectBranch: 'აირჩიეთ ფილიალი',
    selectManager: 'აირჩიეთ მენეჯერი',
    toggleOn: 'ჩართ.',
    toggleOff: 'გამორთ.',
    phFirst: 'მაგ., ნიკოლოზი',
    phLast: 'მაგ., ბარათაშვილი',
    phUsername: 'მაგ., dealer.ge1',
    phEmail: 'dealer@bidmanager.com',
    phPhone: '+995 555 777 777',
    accountAmPlaceholder: '🇬🇪 GE ანგარიში',
    accountUsOptional: '🇺🇸 US ანგარიში (არასავალდებულო)',
    noneOption: 'არცერთი',
    unknownBranch: 'უცნობი ფილიალი',
    bidLimitLabel: 'ბიდის ლიმიტი',
    activeBidsAmountLabel: 'აქტიური ბიდების რაოდენობა',
    activeBidsSumLimitLabel: 'აქტიური ბიდების ჯამური ლიმიტი',
    purchasedCarsLimitLabel: 'შეძენილი მანქანების ლიმიტი',
    lotsEventSettingLabel: 'ლოტების მოვლენის პარამეტრი',
    purchasedLotsSettingLabel: 'შეძენილი ლოტების პარამეტრი',
    showCalculatorWidget: 'კალკულატორის ვიჯეტის ჩვენება',
    showHelperTool: 'დამხმარე ინსტრუმენტის ჩვენება',
    showDiscountRow: 'ფასდაკლების სტრიქონის ჩვენება',
    fixedDiscountAmount: 'ფიქსირებული ფასდაკლების თანხა ($)',
    fixedDiscountHelp: 'ფიქსირებული ფასდაკლება USD-ში',
    iaaiCanadaTitle: 'IAAI (კანადა)',
    calculatorSettingsSection: 'კალკულატორის პარამეტრები',
    auctionLimitsSection: 'აუქციონი და ლიმიტები',
    visibilityHide: 'დამალვა',
    visibilityShow: 'ჩვენება',
    visibilityPartlyShow: 'ნაწილობრივი ჩვენება',
    visibilityWinningLots: 'მოგებული ლოტები',
    colDealer: 'დილერი',
    colBranch: 'ფილიალი',
    colManager: 'მენეჯერი',
    colContact: 'კონტაქტი',
    colSubdealers: 'სუბდილერები',
    colActiveBids: 'აქტიური ბიდები',
    colTotalSpent: 'სულ დახარჯული',
    colCreatedBy: 'შემქმნელი',
    colActions: 'მოქმედებები',
    tooltips: {
      bidLimit: 'მაქსიმალური ბიდის ლიმიტი ერთ ლოტზე',
      activeBidsLimit: 'რამდენი ბიდი გააკეთა მომხმარებელმა უკვე. ახალი მომხმარებლებისთვის დააყენეთ 0',
      activeBidsSumLimit: 'მაქსიმალური მთლიანი თანხა USD-ში, რომელიც მომხმარებელს შეუძლია დადოს ყველა ლოტზე',
      purchasedCarsLimit: 'მაქსიმალური რაოდენობა მანქანების, რომლის შეძენაც შეუძლია მომხმარებელს',
      packageSlug: 'მომხმარებლის პაკეტის ტიპი',
      lotsEventSetting: 'აკონტროლებს წვდომას "ჩემი ბიდები" და "/dashboard" გვერდებზე',
      purchasedLotsSetting: 'აკონტროლებს წვდომას გადახდის დავალიანებისა და გადახდების ისტორიის გვერდებზე',
    },
  },

  // Subdealers
  subdealers: {
    title: 'სუბდილერების მართვა',
    addSubdealer: 'სუბდილერის დამატება',
    editSubdealer: 'სუბდილერის რედაქტირება',
    createSubdealer: 'ახალი სუბდილერის შექმნა',
    assignToDealer: 'დილერზე მინიჭება',
    dealer: 'დილერი',
    branch: 'ფილიალი',
    manager: 'მენეჯერი',
    totalSpent: 'სულ დახარჯული',
    wonAuctions: 'მოგებული აუქციონები',
    activeBids: 'აქტიური ბიდები',
    backToSubdealers: 'დაბრუნება სუბდილერებზე',
    noSubdealersFound: 'სუბდილერები ვერ მოიძებნა',
    deleteSubdealerConfirm: 'დარწმუნებული ხართ, რომ გსურთ სუბდილერის წაშლა',
    tooltips: {
      bidLimit: 'მაქსიმალური ბიდის ლიმიტი ერთ ლოტზე',
      activeBidsLimit: 'რამდენი ბიდი გააკეთა მომხმარებელმა უკვე. ახალი მომხმარებლებისთვის დააყენეთ 0',
      activeBidsSumLimit: 'მაქსიმალური მთლიანი თანხა USD-ში, რომელიც მომხმარებელს შეუძლია დადოს ყველა ლოტზე',
      purchasedCarsLimit: 'მაქსიმალური რაოდენობა მანქანების, რომლის შეძენაც შეუძლია მომხმარებელს',
      packageSlug: 'მომხმარებლის პაკეტის ტიპი',
      lotsEventSetting: 'აკონტროლებს წვდომას "ჩემი ბიდები" და "/dashboard" გვერდებზე',
      purchasedLotsSetting: 'აკონტროლებს წვდომას გადახდის დავალიანებისა და გადახდების ისტორიის გვერდებზე',
    },
  },

  // Bids & Cars
  bids: {
    lotNumber: 'ლოტის ნომერი',
    vin: 'VIN',
    vehicle: 'ავტომობილი',
    bidAmount: 'ბიდის თანხა',
    status: 'სტატუსი',
    bidder: 'მიმთითებელი',
    subdealer: 'სუბდილერი',
    won: 'მოგებული',
    active: 'აქტიური',
    lost: 'წაგებული',
    totalBids: 'სულ ბიდები',
    bidsAndCars: 'ბიდები და მანქანები',
    noBidsFound: 'ბიდები ვერ მოიძებნა',
  },

  layout: {
    footerBrand: 'Bidmanager სისტემა',
  },

  // Auth
  auth: {
    login: 'შესვლა',
    logout: 'გასვლა',
    welcomeBack: 'კეთილი იყოს თქვენი დაბრუნება',
    signIn: 'შესვლა',
    profile: 'პროფილი',
    loginSubtitle: 'ავტომობილების აუქციონის მართვის სისტემა',
    usernamePlaceholder: 'ლოგინი',
    passwordPlaceholder: 'პაროლი',
    signingIn: 'შესვლა...',
    loginFailed: 'შესვლა ვერ მოხერხდა. შეამოწმეთ მონაცემები.',
    connectionError: 'კავშირის შეცდომა. შეამოწმეთ ინტერნეტი და ხელახლა სცადეთ.',
    forgotPasswordQuestion: 'დაგავიწყდათ პაროლი?',
    forgotPasswordTitle: 'პაროლის აღდგენა',
    forgotPasswordHint:
      'შეიყვანეთ ელფოსტა ან ლოგინი (რასაც შესასვლად იყენებთ) პაროლის აღსადგენად.',
    resetByEmail: 'ელფოსტით',
    resetByUsername: 'ლოგინით',
    emailPlaceholder: 'შეიყვანეთ ელფოსტა',
    forgotUsernamePlaceholder: 'შეიყვანეთ ლოგინი',
    sending: 'იგზავნება...',
    sendResetEmail: 'აღდგენის წერილის გაგზავნა',
    checkEmailTitle: 'შეამოწმეთ ელფოსტა',
    checkEmailBody:
      'თუ ანგარიში არსებობს, პაროლის აღდგენის წერილი გამოგეგზავნათ. შეამოწმეთ საფოსტო ყუთი.',
    backToLogin: 'შესვლის გვერდზე დაბრუნება',
    provideEmailOrUsername: 'მიუთითეთ ელფოსტა ან ლოგინი',
    enterEmailAddress: 'შეიყვანეთ ელფოსტის მისამართი',
    enterUsernameRequired: 'შეიყვანეთ ლოგინი',
    requestFailedLater: 'მოთხოვნა ვერ შესრულდა. მოგვიანებით სცადეთ.',
  },

  // Stats
  stats: {
    statistics: 'სტატისტიკა',
    dashboard: 'მთავარი პანელი',
  },

  // Dashboard
  dashboard: {
    systemAdminDashboard: 'სისტემის ადმინისტრატორის პანელი',
    branchManagerDashboard: 'ფილიალის მენეჯერის პანელი',
    dealerDashboard: 'დილერის პანელი',
    yourAuctionDashboard: 'თქვენი აუქციონის პანელი',
    welcomeToDashboard: 'კეთილი იყოს თქვენი მობრძანება Bidmanager-ში',
    welcomeBack: 'კეთილი იყოს თქვენი დაბრუნება',
    systemOverview: 'სისტემის',
    branchOverview: 'ფილიალის',
    activityOverview: 'აქტივობის',
    overview: 'მიმოხილვა',
    hereIsYour: 'აქ არის თქვენი',
    downloadApp: 'აპლიკაციის ჩამოტვირთვა',
    downloadAppDesc: 'ჩამოტვირთეთ ჩვენი მობილური აპლიკაცია აუქციონების მართვისთვის',
    downloadNow: 'ჩამოტვირთვა',
    yourManager: 'თქვენი მენეჯერი',
    yourManagerDesc: 'დაუკავშირდით თქვენს მენეჯერს დახმარებისთვის',
    whatsapp: 'WhatsApp',
    viber: 'Viber',
    tarifPlan: 'ტარიფის გეგმა',
    basic: 'ბაზისური',
    planLimits: '5 მანქანა • $10,000 ლიმიტი',
    upgradePlan: 'გეგმის განახლება',
    quickOverview: 'სწრაფი მიმოხილვა',
    priceList: 'ფასების სია',
    oneActive: '1 აქტიური',
    twoOnline: '2 ონლაინ',
    twoActive: '2 აქტიური',
    name: 'სახელი',
    user: 'მომხმარებელი',
    account: 'ანგარიში',
    auction: 'აუქციონი',
    activity: 'აქტივობა',
    action: 'მოქმედება',
    managePriceLists: 'ფასების სიების მართვა',
    manageSubdealers: 'სუბდილერების მართვა',
    manageAccounts: 'ანგარიშების მართვა',
    online: 'ონლაინ',
    systemMetrics: 'სისტემის მეტრიკა',
    branchPerformance: 'ფილიალის მუშაობა',
    yourActivity: 'თქვენი აქტივობა',
    totalBranches: 'სულ ფილიალები',
    activeBranchesWorldwide: 'აქტიური ფილიალები მსოფლიოში',
    branchManagers: 'ფილიალის მენეჯერები',
    acrossAllBranches: 'ყველა ფილიალში',
    totalRevenue: 'სულ შემოსავალი',
    totalPlatformRevenue: 'პლატფორმის სრული შემოსავალი',
    mySubdealers: 'ჩემი სუბდილერები',
    activeInYourBranch: 'აქტიური თქვენს ფილიალში',
    currentlyInProgress: 'ამჟამად მიმდინარე',
    byYourBranch: 'თქვენი ფილიალის მიერ',
    currentlyBidding: 'ამჟამად ბიდში',
    thisMonth: 'ამ თვეში',
    totalBidsPlaced: 'სულ გაკეთებული ბიდები',
    totalWonAuctions: 'სულ მოგებული აუქციონები',
  },

  // Form validation
  validation: {
    required: 'ეს ველი სავალდებულოა',
    invalidEmail: 'არასწორი ელ-ფოსტის მისამართი',
    passwordMismatch: 'პაროლები არ ემთხვევა',
    minLength: 'მინიმალური სიგრძეა',
    maxLength: 'მაქსიმალური სიგრძეა',
  },

  // Notifications
  notifications: {
    createSuccess: 'წარმატებით შეიქმნა',
    updateSuccess: 'წარმატებით განახლდა',
    deleteSuccess: 'წარმატებით წაიშალა',
    error: 'მოხდა შეცდომა',
  },

  ...sharedCalculatorTranslations,

  // Delivery Cost
  deliveryCost: {
    title: 'მიწოდების ღირებულების მართვა',
    addNew: 'ახალი მდებარეობის დამატება',
    editLocation: 'მდებარეობის რედაქტირება',
    location: 'მდებარეობა',
    fee: 'ღირებულება',
    notes: 'შენიშვნები',
    auction: 'აუქციონი',
    country: 'ქვეყანა',
    armenia: 'სომხეთი',
    georgia: 'საქართველო',
    auctionCopart: 'Copart',
    auctionIaai: 'IAAI',
    auctionManheim: 'Manheim',
    statsCopart: 'Copart:',
    statsIaai: 'IAAI:',
    statsManheim: 'Manheim:',
    totalLocations: 'სულ მდებარეობები',
    searchLocation: 'მდებარეობის ძიება',
    searchPlaceholder: 'მაგ., ატლანტა, ჰიუსტონი...',
    addNotes: 'შენიშვნების დამატება...',
    notesPlaceholder: 'არასავალდებულო შენიშვნები ამ მდებარეობის შესახებ...',
    confirmDelete: 'წაშლის დადასტურება',
    confirmDeleteMessage: 'დარწმუნებული ხართ, რომ გსურთ ამ მიწოდების ღირებულების წაშლა? ეს მოქმედება შეუქცევადია.',
    createSuccess: 'მიწოდების ღირებულება წარმატებით შეიქმნა',
    updateSuccess: 'მიწოდების ღირებულება წარმატებით განახლდა',
    deleteSuccess: 'მიწოდების ღირებულება წარმატებით წაიშალა',
    loadError: 'მიწოდების ღირებულებების ჩატვირთვა ვერ მოხერხდა',
    saveError: 'მიწოდების ღირებულების შენახვა ვერ მოხერხდა',
    deleteError: 'მიწოდების ღირებულების წაშლა ვერ მოხერხდა',
    validationError: 'მდებარეობა და ღირებულება სავალდებულოა',
  },
};

